module.exports = __webpack_public_path__ + "assets/img/EmptyCart@2x.b82b30b9.png";